var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        bottom: "",
        left: "",
        "offset-y": "",
        "close-on-content-click": false,
        "min-width": 300,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var menuAttrs = ref.attrs
            var menuOn = ref.on
            return [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var tooltipAttrs = ref.attrs
                          var tooltipOn = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      fab: "",
                                      small: "",
                                      color: "primary",
                                      "aria-label": _vm.btnAriaLabelAccount,
                                    },
                                  },
                                  "v-btn",
                                  Object.assign({}, menuAttrs, tooltipAttrs),
                                  false
                                ),
                                Object.assign({}, menuOn, tooltipOn)
                              ),
                              [
                                _c("v-icon", { class: _vm.iconColour }, [
                                  _vm._v("mdi-account-outline"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$vuetify.lang.t(
                          "webmap.account.profile.tooltips.profileLinkText"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { "max-width": "300" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: !_vm.useDarkText, dense: "", color: "primary" } },
            [
              _c("v-icon", { class: _vm.accountButtonClass }, [
                _vm._v("mdi-account-outline"),
              ]),
              _vm._v("\n            " + _vm._s(_vm.name) + "\n        "),
            ],
            1
          ),
          _vm._v(" "),
          _vm.canViewOtherMaps
            ? _c(
                "v-list",
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item",
                    { attrs: { dense: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dense: "",
                          items: _vm.maps,
                          "menu-props": "auto",
                          label: _vm.selectLabel,
                          "item-text": "name",
                          "item-value": "name",
                          "return-object": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append-outer",
                              fn: function () {
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "mt-n2",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        fab: "",
                                                        color: "primary",
                                                        "aria-label":
                                                          _vm.btnAriaLabelView,
                                                        href: _vm.mapLink,
                                                        disabled:
                                                          _vm.linkDisabled,
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("mdi-eye"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.btnTooltipView)),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1792044325
                        ),
                        model: {
                          value: _vm.selectedMap,
                          callback: function ($$v) {
                            _vm.selectedMap = $$v
                          },
                          expression: "selectedMap",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _vm.showLogout
                ? _c("a", { attrs: { href: "../Account/profile" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$vuetify.lang.t(
                          "webmap.account.profile.profileLinkText"
                        )
                      )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("a", { attrs: { href: _vm.helpUrl, target: "_blank" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$vuetify.lang.t("webmap.account.profile.helpLinkText")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("a", { attrs: { href: _vm.creditsUrl, target: "_blank" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$vuetify.lang.t(
                      "webmap.account.profile.creditsLinkText"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.showLogout
                ? _c(
                    "v-form",
                    { attrs: { method: "post", action: "../Account/logout" } },
                    [
                      _c(
                        "v-btn",
                        {
                          class: _vm.buttonClass,
                          attrs: { type: "submit", color: "primary" },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.btnTextLogout) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }